module.exports = __webpack_public_path__ + "img/logon_logo2--asset.c21a9dcb.png";